import { render } from "./fifty-banner.vue?vue&type=template&id=1ecf3e40"
import script from "./fifty-banner.vue?vue&type=script&lang=js"
export * from "./fifty-banner.vue?vue&type=script&lang=js"

import "./fifty-banner.vue?vue&type=style&index=0&id=1ecf3e40&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__